<template>
    <ASelect
        mode="multiple"
        v-model:value="valueState"
        placeholder="Pilih User"
        allow-clear
        show-search
        :not-found-content="state.loading ? undefined : 'Tidak ditemukan'"
        option-filter-prop="label"
        option-label-prop="label"
        @search="onSearch"
        @blur="() => (state.params.q = null)"
        @select="() => (state.params.q = null)"
        v-bind="$attrs"
        :loading="state.loading"
        :show-arrow="true"
        style="width:300px">
        <ASelectOption v-for="d in state.data" :key="d.id" :label="d.fullname">
            <span v-html="highlight(d.fullname)"></span>
        </ASelectOption>
        <template v-if="state.loading" #notFoundContent>
            <ASpin size="small" />
        </template>
    </ASelect>
</template>

<script>
import { onMounted, reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce, pickBy } from 'lodash'

export default {
    props: {
        value: {
            type: [Array, Number, Object, String],
            default: null,
        },
        wilayah_id: {
            type: [String, Number],
            default: null,
        },
        distributor_id: {
            type: [String, Number],
            default: null,
        },
        role_id: {
            type: [String, Number],
            default: null,
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const state = reactive({
            endpoint: `/api/filter/user-by-distributor-wilayah`,
            loading: false,
            data: [],
            params: {
                q: '',
                wilayah_id: props.wilayah_id,
                distributor_id: props.distributor_id,
                role_id: props.role_id,
            },
        })

        const fetchData = () => {
            state.loading = true
            apiClient.get(state.endpoint, { params: pickBy(state.params) })
                .then(({ data }) => {
                    state.data = data
                })
                .finally(() => {
                    state.loading = false
                })
        }

        onMounted(() => {
            fetchData()
        })

        watch(() => props.wilayah_id, () => {
            state.params.wilayah_id = props.wilayah_id
        })

        watch(() => props.distributor_id, () => {
            state.params.distributor_id = props.distributor_id
        })

        watch(() => props.role_id, () => {
            state.params.role_id = props.role_id
        })

        watch(state.params, debounce(() => {
            fetchData()
        }, 300))

        const onSearch = value => {
            state.params.q = value
        }

        const highlight = value => {
            return value.replace(new RegExp(state.params.q, 'gi'), match => {
                return `<span style="background-color: yellow;">${match}</span>`
            })
        }

        return {
            state,
            valueState: useVModel(props, 'value'),
            highlight,
            onSearch,
        }
    },
}
</script>